import axios from 'axios';

export const detectLocations = (successCalback = () => {}, failureCallback = () => {}) => {
	if (navigator) {
		navigator.geolocation.getCurrentPosition((res) => {
			const { coords: { latitude, longitude } } = res;
			// send api call
			const data = new URLSearchParams();
			data.append('latitude', latitude);
			data.append('longitude', longitude);
			data.append('distance', 5);
			data.append('distanceType', 'km');
			data.append('resultCount', 1);
			data.append('source', 1);
			axios.post('https://feservices.quikr.com/v2/header/fetch_locality', data, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then((apiResp) => {
				const { data } = apiResp;
				if (data.error) {
					failureCallback({
						code: 143,
						message: 'Api error',
						error: data.error
					});
				}
				else {
					res.cityName = data.cityName;
					res.localityName = data.localityName;
					res.cityId = data.cityId;
					res.localityId = data.localityId;
					successCalback(res);
				}
			});
		}, (err) => {
			failureCallback(err);
		});
	} else {
		failureCallback({
			code: 142,
			message: 'navigator object not found'
		});
	}
};

export const searchCityDefaultCallback = (cityId, cityName, g_id) => {
	const axiosInstance = axios.create({
		baseURL: 'https://www.quikr.com/',
		timeout: 1000,
		headers: {
			accept: 'application/json, text/javascript, */*; q=0.01',
			'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});

	let params = new URLSearchParams();
	params.append('cityName', cityName);
	params.append('categoryId', g_id);
	params.append('gid', '0, www');
	params.append('URL', '/');
	axiosInstance.post('/?aj=1&citysrch=true&sx=true&carsResponsiveLayout=1', params).then((res) => {
		if (res.status === 200) {
			let id = res.data.id;
			let path = window.location.pathname;
			let reg = /cId-[0-9]+|cId[0-9]+/;
			let regw = /w[0-9]+/;
			let regy = /y[0-9]+/;
			let regg = /gId-[0-9]+|gId[0-9]+/;
			let matchcId = path.match(reg);
			let matchwId = path.match(regw);
			let matchyId = path.match(regy);
			let matchgId = path.match(regg);
			let filterParams = window.location.search;
			if (matchcId != null) {
				if (cityId == 0 || cityId == 1) {
					let tmp_gid = matchcId[0].replace(/[0-9]+/, g_id).replace(/cId/, 'gId');
					path = path.replace(reg, tmp_gid);
				} else {
					let tmp_cid = matchcId[0].replace(/[0-9]+/, id);
					path = path.replace(reg, tmp_cid);
				}
			} else if (matchcId == null && matchwId != null) {
				if (cityId == 0 || cityId == 1) {
					path = path.replace(regw, 'y' + g_id);
				} else {
					path = path.replace(regw, 'w' + id);
				}
			} else if (matchyId != null) {
				path = path.replace(regy, 'w' + id);
			} else if (matchgId != null && !(cityId == 0 || cityId == 1)) {
				let tmp_cid = matchgId[0].replace(/[0-9]+/, id).replace(/gId/, 'cId');
				path = path.replace(regg, tmp_cid);
			} else {
				path = '/';
			}
			let subDomain = (cityId != 0 && cityId != 1) ? cityName.toLowerCase() : 'www';

			window.location = window.location.protocol + '//' + subDomain + '.quikr.com' + path + filterParams;
			return;
		} else {
			console.log('Something went wrong');
		}
	}).catch((err) => {
		console.log('Something went wrong');
	});
};


// WEBPACK FOOTER //
// ../q-components/helpers/location.js